// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"564310fe","784":"d80c5434"}[chunkId] + ".chunk.js";
};